import { createAsyncThunk } from "@reduxjs/toolkit";
import { AddressBook } from "./reducer";
import { getErrorMessage, isFresh } from "utils/helpers";
import apiConfig from "constants/apiConfig";
import { fetchAddress } from "services/api/collaboration";

export const fetchAddressThunk = createAsyncThunk(
    'a/address',
    async ({force=false, addressUUID}: {addressUUID: string, force?: boolean}, {getState, rejectWithValue}) => {
        const state = getState() as {addressBook: AddressBook};
        const STALE_TIME = apiConfig.FETCH_ADDRESS.staleTime
        try {
            if(!force && isFresh(state.addressBook.items[addressUUID]?.last_fetched_at, STALE_TIME)){
                return {address: state.addressBook.items[addressUUID].address, cache: true}
            }
            const address = await fetchAddress(addressUUID);
            return {address}
        } catch (error) {
            console.log(error)
            return rejectWithValue(getErrorMessage(error, "failed to fetch address"));
        }

    }
)